import { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";
import { TESTIDS } from "@/constants/testIds";

const KEY = "cdp-cookies-consent-v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(KEY);
      if (!stored) {
        const t = setTimeout(() => setVisible(true), 800);
        return () => clearTimeout(t);
      }
    } catch (e) {
      // ignore
    }
  }, []);

  const close = (status) => {
    try {
      localStorage.setItem(
        KEY,
        JSON.stringify({ status, date: new Date().toISOString() })
      );
    } catch (e) {
      // ignore
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid={TESTIDS.cookieBanner}
      className="fixed bottom-6 left-6 right-6 sm:right-auto sm:max-w-md z-50"
    >
      <div className="relative rounded-2xl border border-[rgba(0,240,255,0.3)] bg-[#0a1224]/95 backdrop-blur-xl p-5 shadow-[0_20px_60px_-12px_rgba(0,240,255,0.25)]">
        <button
          onClick={() => close("dismissed")}
          aria-label="Cerrar"
          className="absolute top-3 right-3 text-[#94a3b8] hover:text-white transition"
        >
          <X size={16} />
        </button>
        <div className="flex items-start gap-4">
          <div className="w-11 h-11 rounded-xl bg-[rgba(0,240,255,0.08)] border border-[rgba(0,240,255,0.3)] flex items-center justify-center shrink-0">
            <Cookie className="text-[#00f0ff]" size={20} />
          </div>
          <div className="flex-1 min-w-0">
            <h4 className="font-display font-bold text-white text-base mb-1.5">
              Usamos cookies 🍪
            </h4>
            <p className="text-[13px] text-[#94a3b8] leading-relaxed mb-4">
              Utilizamos cookies para mejorar tu experiencia, analizar el tráfico
              y personalizar contenido. Al aceptar, consientes su uso en
              cumplimiento con la Ley 21.719.
            </p>
            <div className="flex flex-wrap gap-2">
              <button
                onClick={() => close("accepted")}
                data-testid={TESTIDS.cookieAccept}
                className="inline-flex items-center justify-center bg-[#00f0ff] hover:bg-white text-[#040812] font-semibold text-[13px] px-5 py-2.5 rounded-full transition-all hover:-translate-y-0.5"
              >
                Aceptar todas
              </button>
              <button
                onClick={() => close("rejected")}
                data-testid={TESTIDS.cookieReject}
                className="inline-flex items-center justify-center border border-[rgba(0,240,255,0.3)] hover:border-[#00f0ff] text-white font-medium text-[13px] px-5 py-2.5 rounded-full transition-colors"
              >
                Solo esenciales
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
